import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventClosureReportQueryVariables = Types.Exact<{
  input: Types.GetEventClosureReportInput;
}>;

export type GetEventClosureReportQuery = {
  __typename?: 'Query';
  getEventClosureReport: {
    __typename?: 'GetEventClosureReportResponse';
    cancelledModifiedSessions?: boolean | null;
    cancelledSessionsNote?: string | null;
    clubOfficials?: string | null;
    eventDirector?: string | null;
    eventDirectorConclusion?: string | null;
    eventUuid: string;
    eventsSessionsCount?: number | null;
    fullTimeStaff?: string | null;
    governingBodyOrganiser?: string | null;
    keyHighlights?: string | null;
    keyIssues?: string | null;
    officialsVolunteersCount: number;
    operationalDeliveryRating: string;
    overallAssessmentNote?: string | null;
    overallAssessmentRating: number;
    rainStormActivity?: string | null;
    recommendationCriticality: string;
    recommendationDateRaised: string;
    recommendationOwner: string;
    recommendationText: string;
    reportDate: string;
    scheduleImpact?: string | null;
    spectatorsCount: number;
    submittedAt: string;
    temperatureRange?: string | null;
    totalParticipants: number;
    uuid: string;
    volunteers?: string | null;
    weatherComments?: string | null;
    windConditions?: string | null;
    workforceComments?: string | null;
    weatherConditions?: Array<string> | null;
    operationalAssessments: {
      __typename?: 'GetEventClosureReportOperationalAssessment';
      bumpInOut: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      catering: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      communications: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      eventCommand: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      fieldOfPlay: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      medicalFirstAid: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      operationalOverall: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      planningScheduling: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      registrationOfficials: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      registrationParticipants: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      safetyRiskManagement: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      securityAccessControls: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      spectatorManagement: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      technologyTimingResults: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      transportParking: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      vendors: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
      venueFacilities: {
        __typename?: 'GetEventClosureReportOperationalAssessmentItem';
        comments?: string | null;
        rating: number;
      };
    };
  };
};

export const GetEventClosureReportDocument = gql`
  query GetEventClosureReport($input: GetEventClosureReportInput!) {
    getEventClosureReport(input: $input) {
      cancelledModifiedSessions
      cancelledSessionsNote
      clubOfficials
      eventDirector
      eventDirectorConclusion
      eventUuid
      eventsSessionsCount
      fullTimeStaff
      governingBodyOrganiser
      keyHighlights
      keyIssues
      officialsVolunteersCount
      operationalAssessments {
        bumpInOut {
          comments
          rating
        }
        catering {
          comments
          rating
        }
        communications {
          comments
          rating
        }
        eventCommand {
          comments
          rating
        }
        fieldOfPlay {
          comments
          rating
        }
        medicalFirstAid {
          comments
          rating
        }
        operationalOverall {
          comments
          rating
        }
        planningScheduling {
          comments
          rating
        }
        registrationOfficials {
          comments
          rating
        }
        registrationParticipants {
          comments
          rating
        }
        safetyRiskManagement {
          comments
          rating
        }
        securityAccessControls {
          comments
          rating
        }
        spectatorManagement {
          comments
          rating
        }
        technologyTimingResults {
          comments
          rating
        }
        transportParking {
          comments
          rating
        }
        vendors {
          comments
          rating
        }
        venueFacilities {
          comments
          rating
        }
      }
      operationalDeliveryRating
      overallAssessmentNote
      overallAssessmentRating
      rainStormActivity
      recommendationCriticality
      recommendationDateRaised
      recommendationOwner
      recommendationText
      reportDate
      scheduleImpact
      spectatorsCount
      submittedAt
      temperatureRange
      totalParticipants
      uuid
      volunteers
      weatherComments
      windConditions
      workforceComments
      weatherConditions
    }
  }
`;
export function useGetEventClosureReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventClosureReportQuery,
    GetEventClosureReportQueryVariables
  > &
    (
      | { variables: GetEventClosureReportQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventClosureReportQuery,
    GetEventClosureReportQueryVariables
  >(GetEventClosureReportDocument, options);
}
export function useGetEventClosureReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventClosureReportQuery,
    GetEventClosureReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventClosureReportQuery,
    GetEventClosureReportQueryVariables
  >(GetEventClosureReportDocument, options);
}
export function useGetEventClosureReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventClosureReportQuery,
        GetEventClosureReportQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventClosureReportQuery,
    GetEventClosureReportQueryVariables
  >(GetEventClosureReportDocument, options);
}
export type GetEventClosureReportQueryHookResult = ReturnType<
  typeof useGetEventClosureReportQuery
>;
export type GetEventClosureReportLazyQueryHookResult = ReturnType<
  typeof useGetEventClosureReportLazyQuery
>;
export type GetEventClosureReportSuspenseQueryHookResult = ReturnType<
  typeof useGetEventClosureReportSuspenseQuery
>;
export type GetEventClosureReportQueryResult = Apollo.QueryResult<
  GetEventClosureReportQuery,
  GetEventClosureReportQueryVariables
>;
export function refetchGetEventClosureReportQuery(
  variables: GetEventClosureReportQueryVariables,
) {
  return { query: GetEventClosureReportDocument, variables: variables };
}
